import { render, staticRenderFns } from "./NewsletterSection.vue?vue&type=template&id=dcea0c26&scoped=true&"
import script from "./NewsletterSection.vue?vue&type=script&lang=js&"
export * from "./NewsletterSection.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterSection.vue?vue&type=style&index=0&id=dcea0c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcea0c26",
  null
  
)

export default component.exports